export default "__VITE_ASSET__Ckh8a7Y2__"